export class ReplayPlayer {
  private readonly audio = typeof Audio !== 'undefined' ? new Audio() : null;

  load(src: string): void {
    if (!this.audio) {
      return;
    }

    this.audio.src = src;
  }

  // TODO(audio-notes-ui): expose playback events/state (time updates, ended,
  // buffered ranges) through a hook-facing adapter when the final player UI lands.
  play(): Promise<void> {
    if (!this.audio) {
      return Promise.resolve();
    }

    return this.audio.play();
  }

  pause(): void {
    this.audio?.pause();
  }

  seek(seconds: number): void {
    if (!this.audio) {
      return;
    }

    this.audio.currentTime = seconds;
  }

  get element(): HTMLAudioElement | null {
    return this.audio;
  }

  dispose(): void {
    if (!this.audio) {
      return;
    }

    this.audio.pause();
    this.audio.src = '';
  }
}
